(function() {

    var root = this;
    
    var search = {};

    // Use in node or in browser
    if (typeof exports !== 'undefined') {
        module.exports = search;
    } else {
        root.search = search;
    }

    search.match = function(pattern, searchList, opts){
        opts = opts || {};
        var result = {
            match:false,
            preview:""
        }
            , matchItem = ""
            , patternWords = pattern
                .toLowerCase()
                .replace(/[\_\'\"\.\,]/g, "")
                .replace(/\s+/g, " ")
                .split(" ")
            , equivalencies = []
        
        if (opts.equivalencies){
            equivalencies = opts.equivalencies
        }

        
        // For each word, see if it matches anything in the full string
        searchList.some(s=>{
            let checkWord = s.replace(/[\_\'\"\.\,]/g, "").toLowerCase()
            if (checkWord.indexOf("dept")>-1){
                checkWord += " department"
            } else if (checkWord.indexOf("department")>-1){
                checkWord += " dept"
            }
            if (checkWord.indexOf("washington district")>-1){
                checkWord += " dc"
            }
            let subMatch = true
            patternWords.every((p)=>{
                let check = checkWord.indexOf(p)
                if (check == -1) {
                    subMatch = false
                    return false
                } else {
                    return true
                }
            })
            if (subMatch){
                matchItem = s
                result.match = true
                return true
            } else {
                return false
            }
        })
        if (result.match){
            if (matchItem.indexOf("|")>-1){
                result.preview = matchItem.split("|")[1]
            }
        }


        return result;
    }

    search.filter = function(pattern, arr, opts){
        if(!arr || arr.length === 0) {
            return [];
        }
        if (typeof pattern !== 'string') {
            return arr;
        }
        if (pattern.replace(/[^\w\s\']|_/g, "").replace(/\s+/g, " ")===""){
            return []
        }

        return arr
        .reduce(function(prev, element, idx, arr) {
          var str = element;
          if(opts.extract) {
            str = opts.extract(element);
          }
          var result = search.match(pattern, str, opts);
          if(result.match) {
            prev[prev.length] = {
                string: str
              , preview: result.preview
              , index: idx
              , original: element
            };
          }
          return prev;
        }, [])


    }


}());